import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { authContext } from '@staffedupusa/shared-components';
import { FC, useContext, useState } from 'react';

import { useDeleteApplicantReference } from '@features/applicant/hooks/useDeleteApplicantReference';
import { Close } from '@mui/icons-material';
import { DeleteIcon } from '../../../../vectors/index';

type DeleteApplicantReferenceModalProps = {
  handleClose: () => void;
  referenceId: number | null;
};

const DeleteApplicantReferenceModal: FC<DeleteApplicantReferenceModalProps> = ({
  handleClose,
  referenceId,
}) => {
  const {
    authData: { user },
  } = useContext(authContext);

  const [errorText, setErrorText] = useState('');

  const { deleteApplicantReference, isDeleteApplicantReferenceLoading } =
    useDeleteApplicantReference({
      setErrorText,
      applicantId: user?.id,
    });

  const handleDelete = () =>
    deleteApplicantReference(
      {
        reference_id: referenceId!,
      },
      {
        onSuccess: handleClose,
      },
    );

  if (!referenceId) {
    return null;
  }

  return (
    <Dialog open onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={() => {
            handleClose();
          }}
        >
          <Close />
        </IconButton>
        <br />
        <DeleteIcon />
        <br />
        <Typography variant="h4" sx={{ p: 3 }}>
          Are you sure you want to delete this reference?
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mb={2}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <LoadingButton
            variant="outlined"
            color="error"
            onClick={handleDelete}
            loading={isDeleteApplicantReferenceLoading}
          >
            Delete
          </LoadingButton>
          <Button variant="contained" color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteApplicantReferenceModal;
